import { Component, OnInit } from '@angular/core';
import { GlobalService } from "../../services/global.service"

@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.css']
})
export class NotfoundComponent implements OnInit {

  constructor(private globalService: GlobalService) { }

  ngOnInit() {
  }

  errorText = this.globalService.getNotFoundError();

}
